import { BaseComponentDrawer } from '../../../core/abstraction/BaseComponentDrawer';
import { bigWinService } from '../../../services/helperService/BigWinService';
import { delay } from '../../../core/helpers/delay';

export class BaseBigWinAnimationDrawer extends BaseComponentDrawer {
  onClick() {
    if (bigWinService.isShowedState) {
      if (this.amountGrow.ended) {
        if (bigWinService.has()) {
          bigWinService.resume();
          delay(() => {
            bigWinService.continue();
          }, 200);
        }
        bigWinService.closeBigWin();
      } else {
        this.amountGrow.stop();
      }
    }
  }
}
